import { logoMap } from "assets/logoMap"
import environment from "environments/environment"
import { useEffect, useState } from "react"

export function useLogo() {
  const companyKey = environment.companyKey || "trillium"
  const assets = environment.cdnUrl
  const defaultLogo = logoMap[companyKey]?.logoWithName ?? ""

  const [logo, setLogo] = useState(defaultLogo)
  const [clinicId, setClinicId] = useState(() => sessionStorage.getItem("clinicId"))

  // keep clinicId in sync with sessionStorage (polling version)
  useEffect(() => {
    const interval = setInterval(() => {
      const id = sessionStorage.getItem("clinicId")
      if (id && id !== clinicId) {
        setClinicId(id)
      }
    }, 300)

    return () => clearInterval(interval)
  }, [clinicId])

  // update logo when clinicId changes
  useEffect(() => {
    if (!clinicId) {
      setLogo(defaultLogo)
      return
    }

    const logoUrl = `${assets}/${clinicId}/logo.png`
    const img = new Image()
    img.src = logoUrl
    img.onload = () => setLogo(logoUrl)
    img.onerror = () => setLogo(defaultLogo)
  }, [clinicId, assets, defaultLogo])

  return logo
}

